import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import tDetailActions from 'Actions/taskManage/detail';
import fpListActions from 'Actions/taskManage/firstPage';
import {Select, DatePicker, Table} from 'antd';
import {ExTable} from 'icsoc-antd-ex';

const {
  Filter,
  Filter: {NormalFilter},
} = ExTable;
const {Option} = Select;
const {RangePicker} = DatePicker;

class OutStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      relationList: [],
      repayList: [],
      notConnectedList: [],
      cloumnsRelation: [],
      columnsNotConnected: [],
      coulumnsRepay: [],
      values: {},
    };
  }

  componentDidMount() {
    const {DetailActions} = this.props;
    DetailActions.getTaskNameOptions();
    this.getList();
  }

  // 统计列表
  getList = () => {
    const relationCoulumns = [
      {
        title: '序号',
        dataIndex: 'a',
        key: 'a',
        // width: 70,
        align: 'center',
        className: 'background',
      },
    ];
    const repayCoulumns = [
      {
        title: '序号',
        dataIndex: 'a',
        key: 'a',
        // width: 70,
        align: 'center',
        className: 'background',
      },
    ];
    const notConnectedCoulumns = [
      {
        title: '',
        dataIndex: 'a',
        key: 'a',
        // width: 70,
        align: 'center',
        className: 'background',
      },
    ];
    const {actions} = this.props;
    const {
      values: {date = [], taskId = ''},
    } = this.state;
    const todayStart = `${new Date().toLocaleDateString()} 00:00:00`;
    const todayEnd = `${new Date().toLocaleDateString()} 23:59:59`;
    const params = {
      startTime: date.length
        ? Date.parse(date[0])
        : new Date(todayStart.replace(/-/g, '/')).getTime(),
      endTime: date.length
        ? Date.parse(date[1])
        : new Date(todayEnd.replace(/-/g, '/')).getTime(),
      taskId,
    };
    this.setState({loading: true});
    actions.getTaskFirstPageOutStatusList(params).then(res => {
      const {data, code} = res.payload;
      if (code === 200 && data !== null) {
        // this.setState({loading: false, list: data.list});
        const relationData = data.relationList;
        const repayData = data.codeList;
        const notConnectedData = data.reasonList;
        const relationChange = [{a: '关系确认'}, {a: '输出参数'}];
        const repayChange = [{a: '意向代码'}, {a: '输出参数'}];
        const notConnectedChange = [{a: '未接通数量'}, {a: '比例'}];
        if (relationData !== null && relationData.length !== 0) {
          for (let h = 0; h < relationData.length; h++) {
            relationChange[0][relationData[h].index] = relationData[h].remark;
            relationChange[1][relationData[h].index] = relationData[h].number;
            relationCoulumns.push({
              title: relationData[h].index,
              dataIndex: relationData[h].index,
              key: relationData[h].index,
              // width: 70,
              align: 'center',
            });
          }
        } else {
          relationChange.splice(0, relationChange.length);
        }

        if (repayData !== null && repayData.length !== 0) {
          for (let j = 0; j < repayData.length; j++) {
            repayChange[0][repayData[j].index] = repayData[j].remark;
            repayChange[1][repayData[j].index] = repayData[j].number;
            repayCoulumns.push({
              title: repayData[j].index,
              dataIndex: repayData[j].index,
              key: repayData[j].index,
              // width: 70,
              align: 'center',
            });
          }
        } else {
          repayChange.splice(0, repayChange.length);
        }

        if (notConnectedData !== null && notConnectedData.length !== 0) {
          for (let i = 0; i < notConnectedData.length; i++) {
            notConnectedChange[0][notConnectedData[i].remark] =
              notConnectedData[i].number;
            notConnectedChange[1][notConnectedData[i].remark] =
              notConnectedData[i].rate;
            notConnectedCoulumns.push({
              title: notConnectedData[i].remark,
              dataIndex: notConnectedData[i].remark,
              key: notConnectedData[i].remark,
              // width: 70,
              align: 'center',
            });
          }
        } else {
          notConnectedChange.splice(0, notConnectedChange.length);
        }

        this.setState({
          loading: false,
          notConnectedList: notConnectedChange,
          repayList: repayChange,
          relationList: relationChange,
          columnsNotConnected: notConnectedCoulumns,
          coulumnsRepay: repayCoulumns,
          cloumnsRelation: relationCoulumns,
        });
      } else {
        this.setState({
          loading: false,
          notConnectedList: [],
          repayList: [],
          relationList: [],
          columnsNotConnected: notConnectedCoulumns,
          coulumnsRepay: repayCoulumns,
          cloumnsRelation: relationCoulumns,
        });
      }
    });
  };

  // 搜索
  handleFilter = fields => {
    this.setState({values: fields}, () => {
      this.getList();
    });
  };

  render() {
    const {taskNameOptions} = this.props;
    const {
      loading,
      relationList,
      repayList,
      notConnectedList,
      coulumnsRepay,
      columnsNotConnected,
      cloumnsRelation,
    } = this.state;

    return (
      <div className="outStatus">
        <div className="title">输出状态</div>
        <Filter handleFilter={this.handleFilter}>
          <NormalFilter>
            <NormalFilter.Item label="时间范围" initialValue={[]} field="date">
              <RangePicker />
            </NormalFilter.Item>
            <NormalFilter.Item label="任务名称" field="taskId">
              <Select
                showSearch
                allowClear
                placeholder="请输入内容"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }>
                {Array.isArray(taskNameOptions)
                  ? taskNameOptions.map(({taskId, taskName}) => (
                      <Option value={taskId} key={taskId}>
                        {taskName}
                      </Option>
                    ))
                  : null}
              </Select>
            </NormalFilter.Item>
          </NormalFilter>
        </Filter>
        <div className="tableName">
          <div className="left">
            <span className="light">输出参数：</span>
            <span className="deep">关系确认</span>
          </div>
          <div className="right">
            <span className="light">接通状态：</span>
            <span className="deep">是</span>
          </div>
        </div>
        <Table
          extraHeight={50}
          dataSource={relationList}
          columns={cloumnsRelation}
          loading={loading}
          rowKey="id"
          bordered
          onChange={this.handleTableChange}
          pagination={{position: 'none'}}
        />
        <div className="tableName">
          <div className="left">
            <span className="light">输出参数：</span>
            <span className="deep">还款意向</span>
          </div>
          <div className="right">
            <span className="light">接通状态：</span>
            <span className="deep">是</span>
          </div>
        </div>
        <Table
          extraHeight={50}
          dataSource={repayList}
          columns={coulumnsRepay}
          loading={loading}
          rowKey="id"
          bordered
          onChange={this.handleTableChange}
          pagination={{position: 'none'}}
        />
        <div className="tableName">
          <div className="left">
            <span className="deep">未接通原因</span>
          </div>
          <div className="right">
            <span className="light">接通状态：</span>
            <span className="deep">否</span>
          </div>
        </div>
        <Table
          extraHeight={50}
          dataSource={notConnectedList}
          columns={columnsNotConnected}
          loading={loading}
          rowKey="id"
          bordered
          onChange={this.handleTableChange}
          pagination={{position: 'none'}}
        />
      </div>
    );
  }
}

const mapStateToProps = ({taskManageDetail}) => ({
  taskNameOptions: taskManageDetail.taskNameOptions,
});

const mapDispatchToProps = dispatch => {
  return {
    DetailActions: bindActionCreators(tDetailActions, dispatch),
    actions: bindActionCreators(fpListActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OutStatus);
